import { SharedDocumalisModule } from '@documalis/shared-documalis.module';
import { NgModule } from '@angular/core';
import { TagBaseRoutes } from './tagbase.routes';
import { ListTagBaseComponent } from './list-tagbase/list-tagbase.component';
import { FormTagBaseComponent } from './_components/form-tagbase/form-tagbase.component';
import { AddTagBaseComponent } from './add-tagbase/add-tagbase.component';
import { EditTagBaseComponent } from './edit-tagbase/edit-tagbase.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    imports: [TagBaseRoutes, SharedDocumalisModule, TranslateModule],
    declarations: [ListTagBaseComponent, AddTagBaseComponent, EditTagBaseComponent, FormTagBaseComponent],
})
export class TagBaseModule {}
